/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MonitorProbeResultModel } from '../../models/monitor-probe-result-model';

export interface MonitorProbeGet$Params {
}

export function monitorProbeGet(http: HttpClient, rootUrl: string, params?: MonitorProbeGet$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<MonitorProbeResultModel>> {
  const rb = new RequestBuilder(rootUrl, monitorProbeGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<MonitorProbeResultModel>;
    })
  );
}

monitorProbeGet.PATH = '/Monitor/Probe';
